import { WriterRejectModal } from './WriterRejectModal'
import { withWriterRejectModal } from './withWriterRejectModal'

const ConnectedWriterRejectModal = withWriterRejectModal(WriterRejectModal)
export { ConnectedWriterRejectModal as WriterRejectModal }
